.status {
  svg {
    height: var(--cxy-icon-size-xxsm);
    width: var(--cxy-icon-size-xxsm);
  }

  &.success {
    svg {
      color: var(--cxy-color-content-contrast);
    }
  }
}
